import Vue from 'vue'
import Router from 'vue-router'
// import oidcJS from '../public/oidcRoot'
import commonJs from "../public/common";
import Ajax from '../public/ajax'
import confirmTheInsured from "../components/insuranceInformation/confirmTheInsured";

Vue.use(Router)

const router = new Router({
  base: '/hv2/',
  mode: 'history',
  routes: [
    {
      path: "*",
      redirect: '/home',
      meta: {title: '首页', requireLogin: false,}
    },
    {
      path: '/',
      name: 'home',
      redirect: '/home',
      meta: {title: '首页', requireLogin: false,}
    },
    {
      path: '/loginSuccess',
      name: 'loginSuccess',
      component: resolve => require(['../components/base/loginSuccess'], resolve)
    },

    /*{
      path: '/',
      name: 'main',
      redirect:'/home',
      component: resolve => require(['@/components/base/main'],resolve),
      children:[]*/

    {
      path: '/homePage',
      name: 'homePage',
      component: () => import('../components/home/homePage')
    },
    {
      path: '/home',   // 首页
      name: 'home',
      component: () => import('./../components/home/homePage'),
      meta: {title: '车险投保', requireLogin: true, deepth:1}
    },
    {
      path: '/insuranceInformation',   // 投保信息
      name: 'insuranceInformation',
      component: () => import('./../components/insuranceInformation/insuranceInformation'),
      meta: {title: '填写信息', requireLogin: true,keepAlive:true,deepth:2}
    },
    {
      path: '/vehicleDetails',   // 投保信息
      name: 'vehicleDetails',
      component: () => import('./../components/insuranceInformation/vehicleDetails'),
      meta: {title: '车型明细', requireLogin: true,keepAlive:true,deepth:3}
    },
    {
      path: '/renewalDetails',   // 往年投保
      name: 'renewalDetails',
      component: () => import('./../components/insuranceInformation/renewalDetails'),
      meta: {title: '往年投保', requireLogin: true,keepAlive:true,deepth:3}
    },
    {
      path: '/autoInsuranceQuotes',   // 车险报价
      name: 'autoInsuranceQuotes',
      component: () => import('./../components/offer/autoInsuranceQuotes1'),
      meta: {title: '车险报价', requireLogin: true,keepAlive:true,deepth:3}
    },
    {
      path: '/sharePrice',   // 报价详情弹框
      name: 'sharePrice',
      component: () => import('./../components/common/sharePrice'),
      meta: {title: '报价详情', requireLogin: true}
    },
    {
      path: '/conformPrice',   // 报价详情弹框
      name: 'conformPrice',
      component: () => import('./../components/offer/conformPrice'),
      meta: {title: '报价详情', requireLogin: true,}
    },
    {
      path: '/sharePriceHebao',   // 报价详情弹框
      name: 'sharePriceHebao',
      component: () => import('./../components/offer/sharePriceHebao'),
      meta: {title: '报价详情', requireLogin: true}
    },
    {
      path: '/underwritingInformation',   // 核保页面
      name: 'underwritingInformation',
      component: () => import('./../components/underwriting/underwritingInformation'),
      meta: {title: '核保', requireLogin: true,}
    },
    {
      path: '/underwritingUploadInfo',   // 核保页面
      name: 'underwritingUploadInfo',
      component: () => import('./../components/underwriting/underwritingUploadInfo'),
      meta: {title: '上传资料', requireLogin: true,}
    },
    {
      path: '/confirmTheInsured',   // 确认投保页面
      name: 'confirmTheInsured',
      component: () => import('./../components/insuranceInformation/confirmTheInsured'),
      meta: {title: '确认投保', requireLogin: true,}
    },
    {
      path: '/myOrder',   // 我的订单页面
      name: 'myOrder',
      component: () => import('./../components/order/myOrder'),
      meta: {title: '我的订单', requireLogin: true,keepAlive:true,deepth:1}
    },
    {
      path: '/contributingToRetrieveDialog',   // 特约检索弹框页面
      name: 'contributingToRetrieveDialog',
      component: resolve => require(['@/components/offer/contributingToRetrieveDialog'], resolve)
    },
    {
      path: '/contributToSearchDialog',   // 添加特约检索搜索弹框页面
      name: 'contributToSearchDialog',
      component: () => import('./../components/offer/contributToSearchDialog'),
      meta: {title: '特约检索', requireLogin: true}
    },
    {
      path: '/coversMain',   // 险种选择
      name: 'coversMain',
      component: () => import('./../components/plantedChoice/coversMain'),
      meta: {title: '险种选择', requireLogin: true,keepAlive:true,deepth:1}
    },
    {
      path: '/coverDriving',   // 险种选择
      name: 'coverDriving',
      component: () => import('./../components/plantedChoice/coverDriving'),
      meta: {title: '险种选择', requireLogin: true}
    },
    {
      path: '/additionalInformationDialog',   // 附加信息弹框
      name: 'additionalInformationDialog',
      component: () => import('./../components/offer/additionalInformationDialog'),
      meta: {title: '报价', requireLogin: true}
    },
    {
      path: '/customerService',   // 客服页面，
      name: 'customerService',
      component:  () => import('./../components/customerService/customerService'),
      meta: {title: '客服', requireLogin: true}
    },
    {
      path: '/viewRenewal',   // 首页
      name: 'viewRenewal',
      component: () => import('./../components/home/viewRenewal'),
      meta: {title: '往年投保', requireLogin: true,keepAlive:true}
    },
    {
      path: '/pay',   // 确认投保页面
      name: 'pay',
      component: () => import('./../components/insuranceInformation/payQrCode'),
      meta: {title: '订单支付', requireLogin: true,}
    },
    {
      path: '/underwritingBeforeUploadImgInfo',   // 上传资料，询价完成，核保之前根据保司返回是否上传影像件
      name: 'underwritingBeforeUploadImgInfo',
      component: () => import('./../components/underwriting/underwritingBeforeUploadImgInfo'),
      meta: {title: '上传资料', requireLogin: true,}
    },
    {
      path: '/errorTips',
      name: 'errorTips',
      component: () => import('../components/base/errorTips')
    },
    // ]
    // },
  ]
})
// http://platform.shuabao.com/hv2/home?channelCode=HJ000176&branchId=2c92b3df634a187f01634dddfcf90094
router.beforeEach((to, from, next) => {
  // console.log('路由加载', to)

  commonJs.theme('');

  // 判断是否分享页
  if (to.name == 'sharePrice' || to.name=='conformPrice') {
    next()
  } else {
    if (to.matched.some(record => record.meta.requireLogin)) {  // 判断该路由是否需要登录权限
      let token = commonJs.getQueryString('token')
      if (token) {
        localStorage['token'] = token
        commonJs.loginIn(next, to.fullPath);
      } else {
        if (localStorage['token'] && localStorage['userData']) {
          next();
        } else {
          commonJs.getToken()
        }
      }
    } else {
      next();
    }
  }
})


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js